import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
} from "@mui/material"
import LinearProgress from "@mui/material/LinearProgress"
import Alerts from "../../../../base/errorHandeling/Alerts"
import LoadingButton from "@mui/lab/LoadingButton"
import SaveIcon from "@mui/icons-material/Save"
import CloseIcon from "@mui/icons-material/Close"
import Helpers from "../../../../base/utils/Helpers"
import ImageUpload from "../../../components/imageUpload/ImageUpload"
import "../../../../styleSheets/base/styles.scss"
import "../styles/org.styles.scss"

const OrgsFormModal = (props) => {
  const handleChange = (e) => {
    const value = e.target.value
    props.setData({
      ...props.data,
      [e.target.name]: value,
    })
    props.setUpdatedValues({
      ...props.updatedValues,
      [e.target.name]: value,
    })
    props.setIserror(false)
    props.setErrorMessages([])
  }

  return (
    <Dialog
      fullWidth={true}
      maxWidth="true"
      open={props.open}
      PaperProps={{
        style: { borderRadius: "10px", width: "912px", margin: 0 },
      }}>
      <DialogTitle className="orgFormModalTitle">
        {props.title}
        <IconButton
          aria-label="cancel"
          onClick={() => {
            props.handleClear()
            props.onClose()
          }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={props.handleSubmit}>
        <DialogContent dividers className="orgFormModalContent">
          <div>
            <Alerts
              iserror={props.iserror}
              errorMessages={props.errorMessages}
              isSuccess={props.isSuccess}
              successMessages={props.successMessages}
              iserrorShow={props.iserrorShow}
            />
          </div>
          <div>
            <ImageUpload
              orgLogo={props.orgLogo}
              setProfilePic={props.setProfilePic}
              tooltip={"Upload Organization Logo"}
            />
          </div>
          {props.isLoading && <LinearProgress />}
          <Stack spacing={2} direction="row" sx={{ marginBottom: 2 }}>
            <TextField
              value={props.data.orgName ? props.data.orgName : ""}
              name="orgName"
              type="text"
              variant="outlined"
              color="secondary"
              label="Organization Name"
              fullWidth
              disabled={props.orgNameDisabled}
              required
              onChange={handleChange}
            />
            <TextField
              value={props.data.email ? props.data.email : ""}
              name="email"
              type="email"
              variant="outlined"
              color="secondary"
              label="Email"
              fullWidth
              onChange={handleChange}
            />
          </Stack>
          <Stack spacing={2} direction="row" sx={{ marginBottom: 2 }}>
            <TextField
              value={props.data.primAddress ? props.data.primAddress : ""}
              name="primAddress"
              type="text"
              variant="outlined"
              color="secondary"
              label="Primary Address"
              fullWidth
              required
              onChange={handleChange}
            />
            <TextField
              value={props.data.secAddress ? props.data.secAddress : ""}
              name="secAddress"
              type="text"
              variant="outlined"
              color="secondary"
              label="Secondary Address"
              fullWidth
              onChange={handleChange}
            />
          </Stack>
          <Stack spacing={2} direction="row" sx={{ marginBottom: 2 }}>
            <TextField
              value={props.data.primContact ? props.data.primContact : ""}
              name="primContact"
              type="number"
              placeholder="Enter Primary Contact 07X XXX XXXX"
              variant="outlined"
              color="secondary"
              label="Primary Contact"
              fullWidth
              onChange={handleChange}
              error={props.isPrimContactValid}
              helperText={props.primErrorMessage}
            />
            <TextField
              value={props.data.secContact ? props.data.secContact : ""}
              name="secContact"
              type="number"
              placeholder="Enter Secondary Contact 07X XXX XXXX"
              variant="outlined"
              color="secondary"
              label="Secondary Contact"
              fullWidth
              onChange={handleChange}
              error={props.isSecContactValid}
              helperText={props.secErrorMessage}
            />
          </Stack>
          <TextField
            value={props.data.description ? props.data.description : ""}
            fullWidth
            id="outlined-multiline-static"
            name="description"
            label="Description"
            multiline
            variant="outlined"
            color="secondary"
            rows={4}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button
            onClick={() => {
              props.handleClear()
              props.onClose()
            }}
            variant="outlined"
            color="error">
            Cancel
          </Button>
          <LoadingButton
            type="submit"
            color="success"
            loading={props.isBtnLoading}
            variant="contained"
            loadingPosition="start"
            startIcon={<SaveIcon />}>
            {Helpers.applyRemoverWords(props.title, "Organization")}
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default OrgsFormModal
